import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

//
import { Badge } from "react-bootstrap";

//
import ImageBox from "../general/ImageBox";
import Moment from "react-moment";

//
import { iconImage } from "../../redux/features/coins/actions";

function MobileAlertList({ item }) {
  const convertStatus = (value) => {
    if (value === "won") return "Won";
    if (value === "stopLoss") return "Stoploss";
    if (value === "trendChanged") return "Trend Changed";
    return 'Pending'
  };

  return (
    <div className="box-items">
      <div className="items">
        <header>
          <div className="img-name-status">
            <ImageBox src={iconImage(item.pair)} />
            <div>
              <Link
                to={`/app/coin-detail/${item.pair}`}
                className="fw-bolder text-black"
              >
                {item.name}
              </Link>
              <small
                className={`fw-extra-bolder ${
                  item.signals[0].side == "BUY" ? "text-success" : "text-danger"
                }`}
              >
                {item.signals[0].side}
              </small>
            </div>
          </div>

          <Badge
            bg={item.signals[0].status === "closed" ? "dark" : "secondary"}
          >
            {item.signals[0].status === "closed" ? "Closed" : "Pending"}
          </Badge>
        </header>
        <div className="content zebra">
        <div className="item">
            <small>Enter price</small>
            <small className="text-black">
              {Number(item.signals[0].entryPrice).toFixed(
                item.pair === "BTC" ? 2 : 8
              ).replace(/\.?0+$/, "")}
            </small>
          </div>

          <div className="item">
            <small>Profit / Loss</small>
            <small className="text-black">{item.signals[0].profit} %</small>
          </div>

          <div className="item">
            <small>Win status</small>
            <small className="text-black">
              {convertStatus(item.signals[0].winStatus)}
            </small>
          </div>

          <div className="item">
            <small>Target</small>
            <small className=" text-black">
              <small>
                <span className="fw-extra-bolder">T1.</span>
                {Number(item.signals[0].target).toFixed(
                  item.pair === "BTC" ? 2 : 8
                ).replace(/\.?0+$/, "")}
              </small>
            </small>
          </div>

          <div className="item">
            <small>Date Open (UTC)</small>
            <small>
              <span className="fw-bolder text-black">
                <Moment utc format="MMM DD, YYYY, ">
                  {item.created_at}
                </Moment>
              </span>
              <span>
                <Moment utc format="hh:mm">
                  {item.created_at}
                </Moment>
              </span>
            </small>
          </div>
        </div>
      </div>
    </div>
  );
}

MobileAlertList.propTypes = {
  items: PropTypes.array.isRequired,
};

export default MobileAlertList;
